import http from './axiosInstance'
import errorHandler from '../transformers/axiosErrors'
import { ApiResponse } from '@/types'

export const fetchSetupIntent = async (): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.post(`billing/setup-intent`)
    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }
  return resp
}

export const createSubscription = async (data: any): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.post(`subscriptions`, data, {
      timeout: 60000,
    })
    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }
  return resp
}

export const updatePaymentMethod = async (data: any): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.put(`billing/payment-method`, data, {
      timeout: 60000,
    })
    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }
  return resp
}

export const getPaymentMethod = async (): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.get(`billing/payment-method`)
    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }
  return resp
}

export const getSubscription = async (id: number): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.get(`subscriptions/${id}?includeStripe=1`)
    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }
  return resp
}
